import {CacheState} from "./CacheState";

export class EntityState<T> implements CacheState {
    constructor(public id: number | undefined = undefined,
                public entity: T | null = null,
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}